module.exports = __webpack_public_path__ + "img/00022.a1a699c8.webp";